import { Tooltip } from "primereact/tooltip";
import React, { useEffect, useMemo, useState } from "react";
import { capitalizeEachWord, CardType, PathMadaMap, textProcess } from "./dashbord.model.ts";
import { useAppSelector } from "@core/store/hook.ts";
import { userConnected } from "@core/slice/UsersSlice.ts";
import { TypeProfil } from "@modules/plaintes/plaintes.model.ts";
interface MadagascarMapProps {
  dataMap?: CardType[];
}
interface CardWithExtras extends CardType {
  d: string;
  id: string;
  region: string;
  dy: string;
  dx: string;
  ref: React.RefObject<SVGPathElement>;
}
const MadagascarMap: React.FC<MadagascarMapProps> = ({ dataMap }) => {
  const pathPerRegion = PathMadaMap;
  const detailsUserConnected = useAppSelector(userConnected);
  const [textPositions, setTextPositions] = useState<
    Record<string, { x: number; y: number }>
  >({});
  const [hoveredPath, setHoveredPath] = useState<string | undefined>(undefined);
  const [dataTooltipRegion, setDataTooltipRegion] = useState<CardType>();

  const isInternalAgent = detailsUserConnected && detailsUserConnected.profil.type === TypeProfil.INTERNAL;

  const refs = useMemo(() => {
    const map: Record<string, React.RefObject<SVGPathElement>> = {};
    dataMap?.forEach((item) => {
      map[item.nom] = React.createRef<SVGPathElement>();
    });
    return map;
  }, [dataMap]);
  // On enrichit les données avec les chemins et les refs
  const dataWithExtras: CardWithExtras[] = useMemo(() => {
    return (
      dataMap?.map((item) => {
        const path = pathPerRegion.find((p) => p.region === item.nom);
        if (path) {
          const withRef = {
            ...item,
            d: path.d,
            id: path.id,
            region: path.region,
            ref: refs[item.nom], 
            dy: path.dy, 
            dx: path.dx, 
          };
          return withRef
        }
        return null;
      }).filter((item): item is CardWithExtras => item !== null) || []
    );
  }, [dataMap, pathPerRegion, refs]);
  
  // Calcul des positions une fois que les refs sont montés
  useEffect(() => {
    const newPositions: Record<string, { x: number; y: number }> = {};
    dataWithExtras.forEach((item) => {
      const el = refs[item.nom].current;
      if (el) {
        const pos = getCenterPosition({ current: el });
        if (pos) {
          newPositions[item.nom] = pos;
        }
      }
    });
    setTextPositions(newPositions);
  }, [dataWithExtras, refs]); // refs

  function getCenterPosition(pathRef: any) {
    if (pathRef?.current) {
      const bbox = pathRef.current.getBBox();
      const centerX = bbox.x + bbox.width / 2;
      const centerY = bbox.y + bbox.height / 2;
      return { x: centerX, y: centerY };
    } else {
      return { x: 0, y: 0 };
    }
  }

  function handleMouseEnter(data: CardType) {
    setHoveredPath(data.nom);
    setDataTooltipRegion(data);
  }

  function handleMouseLeave() {
    setHoveredPath(undefined);
  }
  
  const tooltipContent = ( dataTooltipRegion &&
    (<div className="bg-white text-gray-600 m-0 w-full">
      <div className="flex font-bold justify-center items-center w-full">
        Région - {capitalizeEachWord(dataTooltipRegion?.nom)}
      </div>
      <div>
        <span className="tooltipSubTitle">Plaintes reçues</span>: 
        {" "}{dataTooltipRegion?.plainteRecu}
      </div>
      <div>
        <span className="tooltipSubTitle">Résolution</span> : 
        {" "}{parseFloat((dataTooltipRegion?.resolution as number).toFixed(2))}%
      </div>
      <div>
        <span className="tooltipSubTitle">Plaintes en cours </span>: 
        {" "}{dataTooltipRegion?.enCours}
      </div>
      <div>
        <span className="tooltipSubTitle">Catégorie fréquente</span> : 
        {" "}{dataTooltipRegion?.categorieFrequente}
      </div>
      
     {!isInternalAgent && (<div>
         <span className="tooltipSubTitle">Taux de satisfaction</span> :
         {" "}{dataTooltipRegion?.tauxSatisfaction}
      </div>)}
      
    </div>)
  );
  return (
    <>
      <svg
        fill="#FFFFFF"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        version="1.2"
        viewBox="0 0 1000 2000"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full"
        height="90vh"
      >
        {dataWithExtras?.map((item, index) => (
          <g
            onMouseEnter={() => handleMouseEnter(item)}
            onMouseLeave={() => handleMouseLeave()}
            key={index}
          >

            <path
              className={hoveredPath}
              ref={refs[item.nom]}
              d={item.d}
              id={item.id}
              name={item.nom}
              key={item.id}
              // onClick={() => handleAreaClick("Alaotra-Mangoro", "22")}
              style={{
                fill:hoveredPath === item.nom ? "var(--primary-color)" : "#FFFFFF",
                transition: "fill 0.5s ease",
              }}
            />
            {(hoveredPath === undefined || hoveredPath === item.nom) && (
              <text
                x={textPositions[item.nom]?.x ?? 0}
                y={textPositions[item.nom]?.y ?? 0}
                textAnchor="middle"
                dominantBaseline="middle"
                stroke="none"
                fill={hoveredPath === item.nom ? "white" : "#000066"}
              >
                {textProcess(item.nom).map((word, i) => (
                  <tspan
                    key={i}
                    x={textPositions[item.nom]?.x ?? 0}
                    dy={i === 0 ? item.dy : "1.2em"}
                    dx={item.dx}
                    style={{ fontSize: "20px", fontWeight: "bold" }}
                  >
                    {capitalizeEachWord(word)}
                  </tspan>
                ))}
              </text>
            )}
            
          </g>
        ))}
      </svg>
      <Tooltip
        target={`.${hoveredPath}`}
        position="top"
        className="customTooltip"
      >
       {tooltipContent}
      </Tooltip>
    </>
  );
};
export default MadagascarMap;
